import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const state = {
  project: {
    details: []
  },
  details: [],
  shipments: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalProjects: 0,
    totalPages: 0
  }
}

const mutations = {
  SET_PROJECT (state, payload) {
    state.project = payload.data
  },
  SET_DETAILS (state, payload) {
    state.details = payload.data
  },
  SET_SHIPMENTS (state, payload) {
    state.shipments = payload.data
  }
}

const actions = {
  async loadProject ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`projects/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.projects', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PROJECT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadDetails ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`categories-details/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.projects', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_DETAILS', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadShipments ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`shipments?project_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.projects', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SHIPMENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/projects/exportGeneral/${payload}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  project: state => state.project,
  pagination: state => state.pagination,
  details: state => state.details,
  shipments: state => state.shipments
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
